import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

// Libs
import useLiveMallSearchQuery from '@/hooks/useLiveMallSearchQuery'

// Components
import { UserCardList } from '../_shared/UserCardList'

//Constants
import { MemberSearchType } from '@/types/live-mall-search/types'
import { LIVE_MALL_SEARCH_CATEGORY_MAP } from '../../utils/constants'
import { CategorySharedProps } from '../../utils/types'
import { StateHandler } from '../_shared/StateHandler'
import { UserInfo } from '../_shared/UserCardList'

const formatMembers = (members: MemberSearchType[] | undefined): UserInfo[] => {
  if (!members) return []

  return members.map((member) => ({
    memberId: member.id,
    coverImageUrl: member.headshotUrl,
    merchantName: member.nickName,
    location: member.countryCode,
    isFollowed: member.isLike,
  }))
}

const KolContent = ({ allQueryResult, ...props }: CategorySharedProps) => {
  const { keyword, category } = useRouter().query
  const isAllCategory = category === 'all'

  const [members, setMembers] = useState<UserInfo[]>([])
  const isEmpty = members.length === 0
  const { data: memberQueryResult, isFetching } = useLiveMallSearchQuery({
    keyword: String(keyword),
    type: LIVE_MALL_SEARCH_CATEGORY_MAP.KOL,
    enabled: !isAllCategory && !!keyword,
  })
  const queryResult = allQueryResult || memberQueryResult

  useEffect(() => {
    if (queryResult) {
      setMembers(formatMembers(queryResult.memberList))
    }
  }, [queryResult])

  return (
    <StateHandler isFetching={isFetching} isEmpty={isEmpty}>
      <UserCardList users={members} {...props} />
    </StateHandler>
  )
}

export default KolContent
